function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.59 16.41L26.42 23.58C26.2343 23.766 26.0137 23.9135 25.7709 24.0141C25.5281 24.1148 25.2678 24.1666 25.005 24.1666C24.7422 24.1666 24.4819 24.1148 24.2391 24.0141C23.9963 23.9135 23.7757 23.766 23.59 23.58L15 15V5H25L33.59 13.59C33.9625 13.9647 34.1716 14.4716 34.1716 15C34.1716 15.5284 33.9625 16.0353 33.59 16.41V16.41Z",
  stroke: "#303952",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.03775 16.3273C10.3337 16.6196 11.2916 17.734 11.2916 19.0859C11.2916 17.7523 12.2307 16.6561 13.5078 16.3456C12.2119 16.0533 11.254 14.9388 11.254 13.5869C11.2352 14.9206 10.2961 16.035 9.03775 16.3273Z",
  fill: "#2F68CA"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.03756 16.3273L9 16.51C10.202 16.784 11.1223 17.8254 11.1223 19.0859H11.498C11.498 17.8436 12.3807 16.8023 13.564 16.5283V16.1811C12.3619 15.9071 11.4416 14.8658 11.4416 13.6052H11.066C11.066 14.8475 10.1833 15.8888 9 16.1629V16.51L9.03756 16.3273L9.07513 16.51C10.4274 16.1811 11.4229 15.0119 11.4229 13.5869H11.0472C11.0472 15.0119 12.0802 16.2177 13.4513 16.51L13.4888 16.3273L13.4513 16.1446C12.099 16.4735 11.1036 17.6427 11.1036 19.0677H11.4792C11.4792 17.6427 10.4462 16.4369 9.07513 16.1446L9.03756 16.3273L9.07513 16.51L9.03756 16.3273Z",
  fill: "#303952"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.7465 9.05552C11.648 9.25648 12.3242 10.0421 12.3242 10.9738C12.3242 10.0603 12.9816 9.27475 13.8643 9.07379C12.9628 8.87282 12.2866 8.08725 12.2866 7.15552C12.2866 8.06898 11.6293 8.83629 10.7465 9.05552Z",
  fill: "#2F68CA"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7468 9.05552L10.7093 9.23821C11.5169 9.4209 12.1367 10.1334 12.1367 10.9738H12.5123C12.5123 10.1334 13.1133 9.43917 13.9022 9.23821V8.89109C13.0945 8.7084 12.4747 7.9959 12.4747 7.15552H12.0991C12.0991 7.9959 11.4981 8.69013 10.7093 8.89109V9.23821L10.7468 9.05552L10.7844 9.23821C11.7423 9.00071 12.456 8.16032 12.456 7.15552H12.0803C12.0803 8.17859 12.8128 9.03725 13.8083 9.25648L13.8458 9.07379L13.8083 8.89109C12.8504 9.12859 12.1367 9.96898 12.1367 10.9738H12.5123C12.5123 9.95071 11.7798 9.09205 10.7844 8.87282L10.7468 9.05552L10.7844 9.23821L10.7468 9.05552Z",
  fill: "#303952"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.4297 10.499C26.4297 9.16538 27.3688 8.06923 28.6459 7.75865C27.35 7.46634 26.3921 6.35192 26.3921 5C26.3921 6.33365 25.453 7.4298 24.1759 7.74038C25.453 8.03269 26.4297 9.14711 26.4297 10.499Z",
  fill: "#F8986E"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M24.1568 7.74038L24.1193 7.92307C25.3213 8.19711 26.2416 9.23846 26.2416 10.499H26.6172C26.6172 9.25672 27.5 8.21538 28.6832 7.94134V7.59423C27.4812 7.32019 26.5609 6.27884 26.5609 5.01827H26.1853C26.1853 6.26058 25.3025 7.30192 24.1193 7.57596V7.92307L24.1568 7.74038L24.1944 7.92307C25.5467 7.59423 26.5421 6.425 26.5421 5H26.1665C26.1665 6.425 27.1995 7.63077 28.5706 7.92307L28.6081 7.74038L28.5706 7.55769C27.2183 7.88653 26.2228 9.05576 26.2228 10.4808H26.5985C26.5985 9.05576 25.5655 7.85 24.1944 7.55769L24.1568 7.74038L24.1944 7.92307L24.1568 7.74038Z",
  fill: "#303952"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M20 10H20.01",
  stroke: "#0E70B7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M5 3V9",
  stroke: "#F8886E",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M2 6H8",
  stroke: "#F8886E",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgLatitude = function SvgLatitude(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 27,
    viewBox: "0 0 37 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLatitude, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/latitude.2373b67d.svg";
export { ForwardRef as ReactComponent };